import { useState } from '@wordpress/element';
const { __ } = wp.i18n;
import { TextControl, Button, Icon, PanelBody } from '@wordpress/components';
import { plus } from '@wordpress/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import './custom-attribute.css';

const CustomAttributeControl = ({ items = [], onChange }) => {
    const [localItems, setLocalItems] = useState(items);
    const [openIndex, setOpenIndex] = useState(null);

    const addItem = () => {
        const newItems = [...localItems, { name: '', value: '' }];
        setLocalItems(newItems);
        onChange(newItems);
        setOpenIndex(newItems.length - 1);
    };

    const updateItem = (index, field, value) => {
        const newItems = [...localItems];
        newItems[index][field] = value;
        setLocalItems(newItems);
        onChange(newItems);
    };

    const removeItem = (index) => {
        const newItems = localItems.filter((_, i) => i !== index);
        setLocalItems(newItems);
        onChange(newItems);
        if (index === openIndex) {
            setOpenIndex(null);
        }
    };

    return (
        <div className="softlite-custom-attribute-control">
            {localItems.map((item, index) => (
                <PanelBody
                    key={index}
                    title={__(item?.name ? item?.name : 'New Attribute')}
                    className='softlite-custom-attribute-panel'
                    icon={<FontAwesomeIcon icon={faXmark} className='softlite-remove-attribute-button' onClick={() => removeItem(index)} />}
                    opened={index === openIndex}
                    onToggle={() => setOpenIndex(openIndex === index ? null : index)}
                >
                    <div className="softlite-custom-attribute-control__item">
                        <TextControl
                            label="Name"
                            value={item.name}
                            onChange={(value) => updateItem(index, 'name', value)}
                        />
                        <TextControl
                            label="Value"
                            value={item.value}
                            onChange={(value) => updateItem(index, 'value', value)}
                        />
                    </div>
                </PanelBody>
            ))}
            <div className='softlite-add-button-box' style={{ textAlign: 'center' }}>
                <Button className='softlite-add-attribute-button' icon={<Icon icon={plus} size={14} />} onClick={addItem}>
                    Add Attribute
                </Button>
            </div>
        </div>
    );
};

export default CustomAttributeControl;
